const Pod24AdminPRohibited: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          접근 권한이 없습니다
        </h2>
        <p className="text-gray-600">관리자 권한이 필요한 페이지입니다.</p>
      </div>
    </div>
  );
};

export default Pod24AdminPRohibited;
